import { useMemo } from 'react';

import { usePaymentEnv } from '../context/paymentEnvContext';
import { usePaymentRestore } from '../context/paymentRestoreContext';

/**
 * Generates Stripe return_url.
 * Used in both Passenger and Payment apps
 */
function generateStripeRedirectUrl(params: {
	stripeWebCallback: string;
	restorePage: string;
	restoreQuery?: string;
}): string {
	const { stripeWebCallback, restorePage, restoreQuery } = params;

	/** Remove leading '?' from restoreQuery if present */
	const _restoreQuery = new URLSearchParams(restoreQuery || '');

	const url = new URL(`${stripeWebCallback}${restorePage}`);

	_restoreQuery.forEach((value, key) => {
		url.searchParams.set(key, value);
	});

	url.searchParams.set('isPaymentRedirect', 'true');
	url.searchParams.set('payment-method', 'stripe');

	return url.toString();
}

export function useStripeRedirectUrl(): string {
	const { stripeWebCallback } = usePaymentEnv();
	const { restorePage, restoreQuery } = usePaymentRestore();

	return useMemo(
		() =>
			generateStripeRedirectUrl({
				stripeWebCallback,
				restorePage,
				restoreQuery,
			}),
		[stripeWebCallback, restorePage, restoreQuery]
	);
}
